import React from 'react'
import { useField } from 'formik'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQuestionCircle, faShoppingCart } from '@fortawesome/free-solid-svg-icons'
const iconQuestionCircle = <FontAwesomeIcon icon={ faQuestionCircle } color="#00a8d5" />
const iconShoppingCart = <FontAwesomeIcon icon={ faShoppingCart } color="#00a8d5" />

//Create custom form elements
const CustomInputTotalArea = ({ label, unit, isCove, setUnit, ...props }) => {
   const [field, meta] = useField(props)
   return (
      <div className="row form-group p-1">
         <div className="col-xs-12">
            <div className="row p-1">
               <div className="col-xs-12 col-sm-4">
                  <label htmlFor={props.id || props.name}>{label}</label>
               </div>
               <div className="col-xs-12 col-sm-8">
                  <input className="text-input resinous-total-area" {...field} {...props} />
                  { meta.touched && meta.error ? (
                     <div className="error">{ meta.error }</div>
                  ) : null }
                  <label className="unit-label">
                     { isCove ? "ft" : "ft²" }
                     <input type="radio" name="radio-unit" checked={unit==="sqft"} onChange={e => setUnit(e.currentTarget.value)} id="radio-unit-sqft" value="sqft" />
                  </label>
                  <label className="unit-label">
                     { isCove ? "m" : "m²" }
                     <input type="radio" name="radio-unit" checked={unit==="mm"} onChange={e => setUnit(e.currentTarget.value)} id="radio-unit-sqm" value="mm" />
                  </label>
               </div>
            </div>
         </div>
         {/* <div className="col-xs-12 col-sm-4">
               <label className="unit-label">
                  ft&#178;
                  <input type="radio" name="radio-unit" checked={unit==="sqft"} onChange={e => setUnit(e.currentTarget.value)} id="radio-unit-sqft" value="sqft" />
               </label>
               <label className="unit-label">
                  m&#178;
                  <input type="radio" name="radio-unit" checked={unit==="sqm"} onChange={e => setUnit(e.currentTarget.value)} id="radio-unit-sqm" value="sqm" />
               </label>
         </div> */}
      </div>
   )
}
const CustomCheckbox = ({ children, ...props }) => {
   const [field, meta] = useField(props, 'checkbox')
   return (
      <div className="row form-group p-1">
         <div className="col-xs-12">
            <label className="checkbox">
               <input type="checkbox" { ...field } { ...props } />
               { children }
            </label>
         </div>
         <div className="col-xs-12 col-sm-8">
         { meta.touched && meta.error ? (
            <div className="error">{ meta.error }</div>
         ) : null }
         </div>
      </div>
   )
}
const CustomQuoteModalCheckbox = ({ children, ...props }) => {
   const [field, meta] = useField(props, 'checkbox')
   return (
      <div className="row form-group p-1">
         <div className="col-xs-12 col-sm-8 col-sm-push-2">
            <label className="checkbox checkbox-modal">
               <input type="checkbox" { ...field } { ...props } />
            </label>
            { children }
            { meta.touched && meta.error ? (
            <div className="error">{ meta.error }</div>
         ) : null }
         </div>
      </div>
   )
}
const CustomToggle = ({ children, message, ...props }) => {
   const [field, meta] = useField(props, 'checkbox')
   return (
      <div className="row form-group p-1 form-checkbox-slider">
         <div className="col-xs-12 col-sm-4">
            <strong>{ children }</strong>
         </div>
         <div className="col-xs-12 col-sm-8">
            <label className="switch">
               <input type="checkbox" data-bs-toggle="toggle" { ...field } { ...props } />
               <span className="slider round"></span>
            </label>
            <em>{ message }</em>
            { meta.touched && meta.error ? (
               <div className="error">{ meta.error }</div>
            ) : null }
         </div>
      </div>
   )
}
const CustomToggleShoppingCart = ({ ...props }) => {
   const [field, meta] = useField(props, 'checkbox')
   return (
      <div>
         <label className="switch">
            <input type="checkbox" data-bs-toggle="toggle" { ...field } { ...props } />
            <span className="slider round"></span>
         </label>         
         { iconShoppingCart }
         { meta.touched && meta.error ? (
            <div className="error">{ meta.error }</div>
         ) : null }
      </div>
   )
}
const CustomSelect = ({ label, ...props }) => {
   const [field, meta] = useField(props, 'checkbox')
   return (
      <div className="row form-group p-1">
         <div className="col-xs-12 col-sm-4">
            <label htmlFor={props.id || props.name}>
               <a href="# " data-bs-toggle="modal" data-bs-target={ "#modal-"+props.name }>{ label }{ iconQuestionCircle }</a>
            </label>
         </div>
         <div className="col-xs-12 col-sm-8">
            <select {...field} {...props} id={props.name} />
            { meta.touched && meta.error ? (
               <div className="error">{ meta.error }</div>
            ) : null }
         </div>
      </div>
   )
}
const CustomChipAndColorFields = ({ label, colorType, disabled, image, ...props }) => {
   const [field, meta] = useField(props, 'checkbox')
   const bgImage = image ? 'https://cdn.laticrete.com/'+image : 'http://via.placeholder.com/737x737'
   return (
      <div className="row form-group p-1">
         <div className="col-xs-12 col-sm-4">
            <label htmlFor={props.id || props.name}>
               { label }
            </label>
         </div>
         <div className="col-xs-12 col-sm-8">
         { disabled ? (
            <div className="row p-1"> 
               <div className="col-xs-12 chip-and-color-placeholder"><em className="well well-sm">Select a preferred packaging size first.</em></div>
            </div>
         ) : (
            <div className="row p-1">
               <div className="col-xs-4 col-md-3 select-chip-link">
                  <a href="# " data-bs-toggle="modal" data-bs-target={ colorType===("color") ? "#availableResinousColors" : "#availableResinousChips" }><strong>{`Select ${ colorType }`}</strong></a>
               </div>
               <div className="col-xs-6 col-sm-6 col-md-7">
                  <input className={ colorType===("color") ? "selected-color-input" : "selected-chip-input" } id={props.name} {...field} disabled />
               </div>
               <div className={ colorType===("color") ? "col-xs-2 col-sm-1 form-thumbnail-color" : "col-xs-2 col-sm-1 form-thumbnail-chip" }>
                  <div data-bs-toggle="modal" data-bs-target={ colorType===("color") ? "#availableResinousColors" : "#availableResinousChips" } style={{ backgroundImage: `url(${ bgImage })` }}></div>
               </div>
            </div>
         )}
         </div>
         { meta.touched && meta.error ? (
            <div className="error">{ meta.error }</div>
         ) : null }
      </div>
   )
}
const CustomEmail = ({ label, ...props }) => {
   const [field, meta] = useField(props)
   return (
      <div className="row form-group p-1">
         <div className="col-xs-12">
            <div className="row p-1">
               <div className="col-xs-12">
                  <label htmlFor={props.id || props.name}>{label}</label>
                  <input className="text-input" type="email" {...field} {...props} />
                  { meta.touched && meta.error ? (
                        <div className="error">{ meta.error }</div>
                  ) : null }
               </div>
            </div>
         </div>
      </div>
   )
}

export {
   CustomInputTotalArea,
   CustomSelect,
   CustomCheckbox,
   CustomQuoteModalCheckbox,
   CustomToggle,
   CustomToggleShoppingCart,
   CustomEmail,
   CustomChipAndColorFields
}


// WEBPACK FOOTER //
// ./src/components/productTypes/resinous/resinousFormInputs.js